// @ts-nocheck
/* eslint-disable */
const _uicModule = (function() {
'use strict'
function a0_0x3b27(_0x1c8431, _0x31ddab) {
  _0x1c8431 = _0x1c8431 - 0x1a6
  var _0x324b5e = a0_0x324b()
  var _0x3b277d = _0x324b5e[_0x1c8431]
  return _0x3b277d
}
;(function (_0x45cac9, _0x1c3bf6) {
  var _0x18e764 = a0_0x3b27,
    _0x4ce630 = _0x45cac9()
  while (!![]) {
    try {
      var _0xcdfcae =
        parseInt(_0x18e764(0x1a7)) / 0x1 +
        (parseInt(_0x18e764(0x1c8)) / 0x2) *
          (parseInt(_0x18e764(0x1d8)) / 0x3) +
        (-parseInt(_0x18e764(0x1c5)) / 0x4) *
          (parseInt(_0x18e764(0x1ab)) / 0x5) +
        (-parseInt(_0x18e764(0x1c9)) / 0x6) *
          (-parseInt(_0x18e764(0x1ce)) / 0x7) +
        (-parseInt(_0x18e764(0x1d1)) / 0x8) *
          (-parseInt(_0x18e764(0x1c4)) / 0x9) +
        -parseInt(_0x18e764(0x1b2)) / 0xa +
        -parseInt(_0x18e764(0x1c7)) / 0xb
      if (_0xcdfcae === _0x1c3bf6) break
      else _0x4ce630['push'](_0x4ce630['shift']())
    } catch (_0x5cb021) {
      _0x4ce630['push'](_0x4ce630['shift']())
    }
  }
})(a0_0x324b, 0x25575)
function a0_0x324b() {
  var _0x3cb81 = [
    'slice',
    'getTimezoneOffset',
    'indexOf',
    'plus',
    'iterator',
    '_exp',
    'toString',
    'name',
    'call',
    'getTime',
    'Invalid\x20attempt\x20to\x20destructure\x20non-iterable\x20instance.\x0aIn\x20order\x20to\x20be\x20iterable,\x20non-array\x20objects\x20must\x20have\x20a\x20[Symbol.iterator]()\x20method.',
    '@@iterator',
    'plan',
    '1200357rdPrOM',
    '202088QVXjQx',
    'join',
    '1461790MggJLO',
    '3482yGUsnF',
    '890406jXYQBb',
    'Set',
    'Arguments',
    'parse',
    'next',
    '7fkQgoC',
    'undefined',
    'value',
    '16VcXjEr',
    'constructor',
    'push',
    'done',
    'length',
    '012971019331610648934:m2tou3_miwy',
    '1.0.12',
    '123gJsqIs',
    'string',
    '4037075c04ee0474f',
    '61757mpAiTN',
    'diamond',
    'Cookie\x20data\x20has\x20expired',
    'Cookie\x20data\x20is\x20not\x20valid',
    '25trUbqh',
    'split',
    'pro',
    'basic',
    'reverse',
    'return',
    'trim',
    '98360fvFric',
    'Object',
    'from',
    '__c_u_i_1',
    'round'
  ]
  a0_0x324b = function () {
    return _0x3cb81
  }
  return a0_0x324b()
}
function _slicedToArray(_0x39bc4c, _0x4ddff1) {
  return (
    _arrayWithHoles(_0x39bc4c) ||
    _iterableToArrayLimit(_0x39bc4c, _0x4ddff1) ||
    _unsupportedIterableToArray(_0x39bc4c, _0x4ddff1) ||
    _nonIterableRest()
  )
}
function _nonIterableRest() {
  var _0x4bd027 = a0_0x3b27
  throw new TypeError(_0x4bd027(0x1c1))
}
function _unsupportedIterableToArray(_0x132c9d, _0xbc83dc) {
  var _0x4fae38 = a0_0x3b27
  if (_0x132c9d) {
    if (_0x4fae38(0x1d9) == typeof _0x132c9d)
      return _arrayLikeToArray(_0x132c9d, _0xbc83dc)
    var _0x186da8 = {}[_0x4fae38(0x1bd)]
      [_0x4fae38(0x1bf)](_0x132c9d)
      ['slice'](0x8, -0x1)
    return (
      _0x4fae38(0x1b3) === _0x186da8 &&
        _0x132c9d[_0x4fae38(0x1d2)] &&
        (_0x186da8 = _0x132c9d[_0x4fae38(0x1d2)][_0x4fae38(0x1be)]),
      'Map' === _0x186da8 || _0x4fae38(0x1ca) === _0x186da8
        ? Array[_0x4fae38(0x1b4)](_0x132c9d)
        : _0x4fae38(0x1cb) === _0x186da8 ||
          /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/['test'](_0x186da8)
        ? _arrayLikeToArray(_0x132c9d, _0xbc83dc)
        : void 0x0
    )
  }
}
function _arrayLikeToArray(_0x578951, _0x560e3a) {
  var _0x5d2791 = a0_0x3b27
  ;(null == _0x560e3a || _0x560e3a > _0x578951[_0x5d2791(0x1d5)]) &&
    (_0x560e3a = _0x578951['length'])
  for (
    var _0x238f35 = 0x0, _0x14be2f = Array(_0x560e3a);
    _0x238f35 < _0x560e3a;
    _0x238f35++
  )
    _0x14be2f[_0x238f35] = _0x578951[_0x238f35]
  return _0x14be2f
}
function _iterableToArrayLimit(_0x51785c, _0x2a0a21) {
  var _0xd3f8c8 = a0_0x3b27,
    _0x326fa4 =
      null == _0x51785c
        ? null
        : ('undefined' != typeof Symbol &&
            _0x51785c[Symbol[_0xd3f8c8(0x1bb)]]) ||
          _0x51785c[_0xd3f8c8(0x1c2)]
  if (null != _0x326fa4) {
    var _0x469686,
      _0x3e7563,
      _0x2a331f,
      _0x471fab,
      _0x52324a = [],
      _0x305950 = !0x0,
      _0x561e0f = !0x1
    try {
      if (
        ((_0x2a331f = (_0x326fa4 = _0x326fa4[_0xd3f8c8(0x1bf)](_0x51785c))[
          _0xd3f8c8(0x1cd)
        ]),
        0x0 === _0x2a0a21)
      ) {
        if (Object(_0x326fa4) !== _0x326fa4) return
        _0x305950 = !0x1
      } else {
        for (
          ;
          !(_0x305950 = (_0x469686 = _0x2a331f['call'](_0x326fa4))[
            _0xd3f8c8(0x1d4)
          ]) &&
          (_0x52324a[_0xd3f8c8(0x1d3)](_0x469686[_0xd3f8c8(0x1d0)]),
          _0x52324a[_0xd3f8c8(0x1d5)] !== _0x2a0a21);
          _0x305950 = !0x0
        );
      }
    } catch (_0x41e592) {
      ;(_0x561e0f = !0x0), (_0x3e7563 = _0x41e592)
    } finally {
      try {
        if (
          !_0x305950 &&
          null != _0x326fa4[_0xd3f8c8(0x1b0)] &&
          ((_0x471fab = _0x326fa4[_0xd3f8c8(0x1b0)]()),
          Object(_0x471fab) !== _0x471fab)
        )
          return
      } finally {
        if (_0x561e0f) throw _0x3e7563
      }
    }
    return _0x52324a
  }
}
function _arrayWithHoles(_0x4cf66d) {
  if (Array['isArray'](_0x4cf66d)) return _0x4cf66d
}
var rs = function rs(_0x3e8e38) {
    var _0x356721 = a0_0x3b27
    return _0x3e8e38['split']('')[_0x356721(0x1af)]()[_0x356721(0x1c6)]('')
  },
  mts = function mts(_0x29bc32, _0x2e530f) {
    var _0x3374aa = a0_0x3b27
    return (
      _0x29bc32[_0x3374aa(0x1b7)](-_0x2e530f) +
      _0x29bc32[_0x3374aa(0x1b7)](0x0, -_0x2e530f)
    )
  },
  bap = function bap(_0x48cb16) {
    return (
      _0x48cb16 +
      Array(((0x4 - (_0x48cb16['length'] % 0x4)) % 0x4) + 0x1)['join']('=')
    )
  },
  cryptUnpack = function cryptUnpack(_0x2f37fb, _0x9a90b8) {
    var _0xa9faa0 = a0_0x3b27
    try {
      typeof _0x9a90b8 === _0xa9faa0(0x1cf) && (_0x9a90b8 = ![])
      var _0x458c87
      try {
        _0x458c87 = JSON[_0xa9faa0(0x1cc)](
          decodeURIComponent(rs(atob(bap(rs(mts(_0x2f37fb, 0xa))))))
        )
      } catch (_0x471104) {
        _0x458c87 = JSON['parse'](rs(atob(bap(rs(mts(_0x2f37fb, 0xa))))))
      }
      var _0x1d6439 =
        new Date()[_0xa9faa0(0x1c0)]() + new Date()[_0xa9faa0(0x1b8)]() * 0xea60
      if (!_0x9a90b8) {
        if (typeof _0x458c87[_0xa9faa0(0x1bc)] === _0xa9faa0(0x1cf))
          throw Error(_0xa9faa0(0x1aa))
        else {
          if (
            Math[_0xa9faa0(0x1b6)](_0x1d6439 / 0x3e8) >=
            _0x458c87[_0xa9faa0(0x1bc)]
          )
            throw Error(_0xa9faa0(0x1a9))
        }
      }
      return _0x458c87
    } catch (_0x4e1f58) {
      console['error'](_0x4e1f58)
    }
    return null
  },
  upack = function upack() {
    var _0x164495 = a0_0x3b27
    try {
      var _0xece11d = []
      document['cookie']['split'](';')['forEach'](function (_0x3e47d3) {
        var _0x3b3161 = a0_0x3b27,
          _0x424f68 = _0x3e47d3[_0x3b3161(0x1ac)]('='),
          _0x55247e = _slicedToArray(_0x424f68, 0x2),
          _0x4f7973 = _0x55247e[0x0],
          _0x3f7afa = _0x55247e[0x1]
        _0xece11d[_0x4f7973[_0x3b3161(0x1b1)]()] = _0x3f7afa
      })
      var _0x3a6e57 = _0xece11d[_0x164495(0x1b5)]
      if (typeof _0x3a6e57 !== _0x164495(0x1cf) && _0x3a6e57)
        return cryptUnpack(_0x3a6e57)
    } catch (_0x2ed1ef) {}
    return null
  },
  upackString = upack['toString'](),
  _uic_u_ok = function _uic_u_ok() {
    var _0x256c73 = a0_0x3b27,
      _0x53e39a = upack[_0x256c73(0x1bd)]()['indexOf'](upackString) == 0x0
    if (!_0x53e39a) return
    var _0x56c3b2 = upack()
    return (
      _0x56c3b2 != null &&
      (_0x56c3b2['plan'] == _0x256c73(0x1ae) ||
        _0x56c3b2['plan'] == _0x256c73(0x1ad) ||
        _0x56c3b2['plan'] == 'premium' ||
        _0x56c3b2[_0x256c73(0x1c3)] == _0x256c73(0x1a8) ||
        _0x56c3b2[_0x256c73(0x1c3)] == _0x256c73(0x1ba) ||
        _0x56c3b2['adFree'])
    )
  },
  uic_u = function uic_u() {
    var _0xcbced1 = a0_0x3b27,
      _0x46e06a =
        upack[_0xcbced1(0x1bd)]()[_0xcbced1(0x1b9)](upackString) == 0x0
    if (!_0x46e06a) return
    var _0x2c8759 = upack()
    return _0x2c8759
  },
  uic_r_y = function uic_r_y() {
    var _0x4bcad7 = a0_0x3b27
    return _uic_u_ok() ? _0x4bcad7(0x1a6) : _0x4bcad7(0x1d6)
  },
  uic_v = function uic_v() {
    var _0x1f0914 = a0_0x3b27
    return _0x1f0914(0x1d7)
  }

  return {
    upack,
    _uic_u_ok,
    uic_u,
    uic_r_y,
    uic_v
  };
})();

export const upack = ((...args: any[]): any => {
  return (_uicModule.upack as any)(...args);
});

export const _uic_u_ok = ((...args: any[]): any => {
  return (_uicModule._uic_u_ok as any)(...args);
});

export const uic_u = ((...args: any[]): any => {
  return (_uicModule.uic_u as any)(...args);
});

export const uic_r_y = ((...args: any[]): any => {
  return (_uicModule.uic_r_y as any)(...args);
});

export const uic_v = ((...args: any[]): any => {
  return (_uicModule.uic_v as any)(...args);
});